// 对Date的扩展，将 Date 转化为指定格式的String
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.format = function (fmt) {
  const o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
    // "W"  : this.weekday()
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    );
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      );
    }
  }
  return fmt;
};

/**
 * @Desc: 根据UA指定渠道
 */
const getTenantAccordingToUA = () => {
  switch (true) {
    case isMobile.AliApp():
      return 'alipay';
    case isMobile.Taobao():
      return 'taobao';
    case isMobile.Food():
      return 'food';
    case isMobile.BooheeHealth():
      return 'boohee';
    default:
      return '';
  }
};
const isMobile = {
  Windows: function () {
    return /IEMobile/i.test(navigator.userAgent);
  },
  Android: function () {
    return /Android/i.test(navigator.userAgent);
  },
  iOS: function () {
    return /iPhone|iPad|iPod|iOS|Mac/i.test(navigator.userAgent);
  },
  Hw: function () {
    return /HuaweiHealth/.test(navigator.userAgent);
  },
  HarmonyOS: () => {
    return /HarmonyOS/i.test(navigator.userAgent);
  },
  Hos: function () {
    return /hos\/boohee/i.test(navigator.userAgent);
  },
  app: function () {
    const standalone = window.navigator.standalone,
      userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari|micromessenger/.test(userAgent),
      ios = /iphone|ipod|ipad/.test(userAgent);

    let result = false;
    if (ios) {
      if (!standalone && !safari) {
        result = true;
      }
    } else {
      if (/boohee/.test(userAgent)) {
        result = true;
      }
    }
    return result;
  },
  weixin: function () {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('micromessenger') !== -1;
  },
  Boohee: function () {
    return /boohee/i.test(navigator.userAgent);
  },
  BooheeIOS: function () {
    return this.iOS() && this.Boohee();
  },
  BooheeAndroid: function () {
    return this.Android() && this.Boohee();
  },
  BooheeHealth: function () {
    return this.Boohee() && !/food/i.test(navigator.userAgent);
  },
  BooheeHealthIOS: function () {
    return this.iOS() && this.BooheeHealth();
  },
  BooheeHealthAndroid: function () {
    return this.Android() && this.BooheeHealth();
  },
  Food: function () {
    return this.Boohee() && /food/i.test(navigator.userAgent);
  },
  FoodIOS: function () {
    return this.iOS() && this.Food();
  },
  FoodAndroid: function () {
    return this.Android() && this.Food();
  },
  AliApp: () => {
    return /AliApp/i.test(navigator.userAgent);
  },
  Alipay: () => {
    return /AlipayClient/i.test(navigator.userAgent);
  },
  Taobao: () => {
    return (
      /AliApp/i.test(navigator.userAgent) && /TB/i.test(navigator.userAgent)
    );
  },
  AliHealth: () => {
    return (
      /AliApp/i.test(navigator.userAgent) &&
      /AliHealthClient/i.test(navigator.userAgent)
    );
  },
  WeixinMiniProgram: () => {
    return window.__wxjs_environment === 'miniprogram';
  }
};

const pxTransform = (px) => {
  const windowWidth = window.innerWidth;
  const transformPx = (windowWidth / 375) * px;
  return transformPx;
};

const orderBy = (arr, props, orders) =>
  [...arr].sort((a, b) =>
    props.reduce((acc, prop, i) => {
      if (acc === 0) {
        const [p1, p2] =
          orders && orders[i] === 'desc'
            ? [b[prop], a[prop]]
            : [a[prop], b[prop]];
        acc = p1 > p2 ? 1 : p1 < p2 ? -1 : 0;
      }
      return acc;
    }, 0)
  );

export const ShareTypeEnum = {
  IOS: 'https://itunes.apple.com/cn/app/id457856023?mt=8',
  Android: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.boohee.one'
};
/**
   * @description 获取下载最新 薄荷健康 APP 版本的链接
   * @returns {string}
   */
export const getDownLoadBooheeHealthUrl = () => {
  if (isMobile.BooheeHealth()) {
    if (isMobile.iOS()) {
      return ShareTypeEnum.IOS;
    } else {
      return ShareTypeEnum.Android;
    }
  }
  return '';
};

// 封装 获取安卓手机品牌方
function judgeBrand(userAgent) {
  if (!isMobile.Android()) return '';
  switch (true) {
    case /huawei|honor/.test(userAgent):
      return 'huawei';
    case /oppo|pacm00/.test(userAgent):
      return 'nearme';
    case /vivo/.test(userAgent):
      return 'vivo';
    case /mi\s|mix\s|redmi/.test(userAgent):
      return 'xiaomi';
    default:
      return '';
  }
}
const filterImage = (url, isAvatar) => {
  if (!url) {
    return '';
  }
  if (isAvatar) {
    if (!url.includes('?')) {
      url += '?imageView2/2/w/120/format/jpg';
    }
    return url;
  }
  if (url.includes('bj.')) {
    if (!url.includes('?')) {
      url += '?x-oss-process=image/resize,h_500,m_lfit&imageView2/2/h/500';
    }
  } else if (url.includes('onetest.') || url.includes('one.') || url.includes('up.')) {
    const type = localStorage.getItem('supportWebP') === 'true' ? 'webp' : 'jpg';
    if (!url.includes('?')) {
      url += `?imageView2/2/format/${type}|imageMogr2/strip`;
    } else if (url.includes('imageView2/2/format/webp')) {
      url = url.replace('imageView2/2/format/webp', `imageView2/2/format/${type}`);
    }
  }
  return url;
};
function checkWebPSupport() {
  const img = new Image();
  img.onload = () => {
    localStorage.setItem('supportWebP', (img.width > 0) && (img.height > 0) ? 'true' : 'false');
  };
  img.onerror = () => {
    localStorage.setItem('supportWebP', 'false');
  };
  img.src = 'data:image/webp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==';
}
export default {
  getQueryString(name, url) {
    if (!url) url = window.location.href;
    if (!name) {
      // 如果没有参数，默认获取全部
      try {
        url = url.match(/\?([^#]+)/)[1];
        const obj = {},
          arr = url.split('&');
        for (let i = 0; i < arr.length; i++) {
          const subArr = arr[i].split('=');
          const key = decodeURIComponent(subArr[0]);
          const value = decodeURIComponent(subArr[1]);
          obj[key] = value;
        }
        return obj;
      } catch (err) {
        return null;
      }
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  getBooheeAppVersion() {
    let version = '';
    if (isMobile.BooheeHealth()) {
      const flag = 'boohee/';
      const userAgent = navigator.userAgent;
      version = userAgent.slice(userAgent.indexOf(flag) + flag.length);
    }
    return version.replace(/iOS\//, '');
  },
  /**
   * 比较两个版本的大小
   * 返回false说明版本ver1大于版本ver2
   * 返回true说明版本ver1小于版本ver2
   * 返回equal说明版本ver1等于版本ver2
   */
  versionCompare(ver1, ver2) {
    if (!ver1 || !ver2) return false;
    if (ver1 === ver2) {
      return 'equal';
    }
    const nowVersionList = ver1.split('.');
    const targetVersionList = ver2.split('.');
    let target = false;
    for (let index = 0; index < nowVersionList.length; index++) {
      const item = nowVersionList[index];
      if (+item > +targetVersionList[index]) {
        target = false;
        break;
      } else if (+item < +targetVersionList[index]) {
        target = true;
        break;
      }
    }
    return target;
  },
  myRegExp: {
    isPhoneNumber: data => {
      const reg = /^1[0-9]{10}$/;
      if (reg.test(data)) {
        return true;
      } else {
        return false;
      }
    },
    isEmail: data => {
      const reg = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g;
      if (reg.test(data)) {
        return true;
      } else {
        return false;
      }
    },
    isWeixin: data => {
      const reg = /^[-_a-zA-Z0-9]{6,20}$/;
      if (reg.test(data)) {
        return true;
      } else {
        return false;
      }
    }
  },
  isMobile,
  pxTransform,
  orderBy,
  judgeBrand,
  getDownLoadBooheeHealthUrl,
  filterImage,
  checkWebPSupport,
  getTenantAccordingToUA
};
